"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultNearbymapState = void 0;
var small = {
    mapState: {
        center: {
            lat: 22.3531523,
            lng: 114.1815688,
        },
        zoom: 12,
    },
    objects: [],
};
var big = __assign(__assign({}, small), { properties: [], savedPlaces: [], results: [], popNearbyMore: false, popNearbyAddPlace: false });
exports.defaultNearbymapState = {
    small: small,
    big: big,
};
